export const MANIFESTACAO_LINHA_EXPANDIDA_CLASSE = 'manifestacao-linha-expandida';

export function classeLinhaManifestacaoExpandida(row, idsExpandidos) {
  if (!row?.id || !Array.isArray(idsExpandidos) || !idsExpandidos.length) {
    return '';
  }

  return idsExpandidos.includes(row.id) ? MANIFESTACAO_LINHA_EXPANDIDA_CLASSE : '';
}
